/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: "PrivacyPolicy",
};

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "content-container" }, [
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _vm._m(5),
      _vm._v(" "),
      _vm._m(6),
      _vm._v(" "),
      _vm._m(7),
      _vm._v(" "),
      _vm._m(8),
      _vm._v(" "),
      _c("section", [
        _c("h3", [_vm._v("7. YOUR RIGHTS")]),
        _vm._v(" "),
        _c("p", [_vm._v("You have the right to:")]),
        _vm._v(" "),
        _vm._m(9),
        _vm._v(" "),
        _c("p", [
          _vm._v("To exercise any of these rights, please email us at "),
          _c("a", { attrs: { href: "mailto:einvoice@win2food.com.my" } }, [
            _vm._v("einvoice@win2food.com.my")
          ]),
          _vm._v(".")
        ])
      ]),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _vm._m(11),
      _vm._v(" "),
      _c("section", [
        _c("h3", [_vm._v("10. CONTACT US")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "If you have any questions about this Privacy Policy or our data practices, please contact us at:"
          )
        ]),
        _vm._v(" "),
        _c("ul", [
          _c("li", { staticStyle: { "margin-bottom": "0.5rem" } }, [
            _c("strong", [_vm._v("Email:")]),
            _vm._v(" "),
            _c("a", { attrs: { href: "mailto:einvoice@win2food.com.my" } }, [
              _vm._v("einvoice@win2food.com.my")
            ])
          ]),
          _vm._v(" "),
          _vm._m(12),
          _vm._v(" "),
          _vm._m(13)
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "By providing your information to us, you agree to the terms outlined in this Privacy Policy."
          )
        ])
      ])
    ])
  ])
}
var __vue_staticRenderFns__ = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-container" }, [
      _c("h1", { staticClass: "header-title" }, [_vm._v("Privacy Policy")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("Last Updated:")]),
      _vm._v(" 1st Jan 2025")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("strong", [_vm._v("Win2 Food Marketing Sdn. Bhd")]),
      _vm._v(
        '. ("we," "us," "our") is committed to protecting your privacy and ensuring\n            your personal data is handled securely and in compliance with applicable laws. This Privacy Policy\n            explains how we collect, use, and safeguard your information, particularly when interacting with us\n            through our e-invoice digital forms.\n        '
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("1. WHO ARE WE")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n                When this Privacy Policy refers to "we" or "us," it means Win2 Food Marketing Sdn. Bhd. and its\n                related entities.\n            '
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("2. WHAT TYPE OF INFORMATION DO WE COLLECT?")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("Personal Identification Information:")]),
          _vm._v(
            " Your name, personal tax TIN ID,\n                    identification number, email address, mobile phone number, address, and postal code."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Company Information:")]),
          _vm._v(
            " Your company name, company registration number, company\n                    tax TIN number, SST number, email address, and phone number."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Interaction Details:")]),
          _vm._v(
            " Information about your interactions with us, including any\n                    complaints or comments you made, details of purchases, and how and when you contact us."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Shopping Preferences:")]),
          _vm._v(
            " Information about your preferences, such as preferred\n                    stores or products."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Technical Information:")]),
          _vm._v(
            " Details of your visits to our websites, including IP\n                    address, browser type, and pages visited."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Cookies and Similar Technologies:")]),
          _vm._v(
            " Information gathered by the use of cookies to\n                    enhance your experience on our website."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Third-Party Information:")]),
          _vm._v(
            " Information received from affiliates, referral\n                    programs, marketing service providers, or publicly available sources."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("3. HOW AND WHY DO WE USE YOUR PERSONAL DATA?")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("Comply with Legal Obligations:")]),
          _vm._v(
            " To fulfill regulatory requirements, including\n                    LHDN e-invoice compliance."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Provide and Improve Our Services:")]),
          _vm._v(
            " To manage your account, process requests, and\n                    enhance your experience with our services."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Personalization:")]),
          _vm._v(
            " To tailor promotions, services, and products to your\n                    preferences."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Communication:")]),
          _vm._v(" To respond to your inquiries, feedback, or complaints.")
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Fraud Prevention and Security:")]),
          _vm._v(
            " To safeguard our customers, employees, and\n                    business from illegal activities."
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("4. HOW DO WE PROTECT YOUR PERSONAL DATA?")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                We prioritize the security of your personal data by implementing robust technical and organizational\n                measures to prevent unauthorized access, disclosure, or alteration of your information. These\n                measures include encryption, access control, and regular security audits.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("5. SHARING YOUR PERSONAL DATA")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We may share your personal data with trusted third parties under the following conditions:"
        )
      ]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("Regulatory Compliance")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Information may be disclosed to Malaysian regulatory bodies, such as:\n                            "
              ),
              _c("ul", [
                _c("li", [
                  _vm._v("Lembaga Hasil Dalam Negeri Malaysia (LHDN).")
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("Royal Malaysian Customs Department.")])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Purpose: To fulfill tax, e-invoicing, and SST compliance obligations."
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Third-Party Service Providers")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "We collaborate with service providers to support business operations, such as:\n                            "
              ),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "Payment Processors: To handle secure payments and refunds."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Cloud Storage Providers: For safe data storage within Malaysia or countries with\n                                    equivalent data protection laws."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "IT Support and Cybersecurity Firms: To ensure system and data security."
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Marketing and Advertising Partners")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "With your explicit consent, your data may be shared with marketing agencies to:\n                            "
              ),
              _c("ul", [
                _c("li", [_vm._v("Deliver personalized advertisements.")]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Offer promotional deals relevant to your preferences."
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Affiliates or Business Partners")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Data may be shared with affiliated companies or joint venture partners for:\n                            "
              ),
              _c("ul", [
                _c("li", [
                  _vm._v(
                    "Operational purposes, such as shared systems or customer support."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "In compliance with Malaysia’s Personal Data Protection Act (PDPA)."
                  )
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Legal and Risk Management")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Personal data may be disclosed to:\n                            "
              ),
              _c("ul", [
                _c("li", [
                  _vm._v("Legal counsel, auditors, or insurance companies.")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v("Purpose: For claims, disputes, or risk assessments.")
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "We ensure that all third parties handling your personal data adhere to strict confidentiality and\n                security standards as required by the PDPA and other relevant Malaysian laws."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("6. DATA RETENTION")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Whenever we collect or process your personal data, we will only keep it for as long as is necessary\n                for the purpose for which it was collected or to comply with legal and regulatory requirements. For\n                tax and compliance purposes, we may retain your data for a minimum of seven (7) years. At the end of\n                that retention period, your data will either be deleted completely or anonymized, for example by\n                aggregation with other data so that it can be used in a non-identifiable way for statistical\n                analysis and business planning."
        )
      ]),
      _vm._v(" "),
      _c("p", [_vm._v("Key retention details include:")]),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c("strong", [_vm._v("Personal Identification Information:")]),
          _vm._v(
            " Retained for 7 years after the end of our\n                    business relationship to comply with Malaysian taxation and accounting laws."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Company Information:")]),
          _vm._v(
            " Retained for 7 years to meet statutory obligations under\n                    the Companies Act 2016 and related regulations."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Transaction and Interaction Details:")]),
          _vm._v(
            " Retained for 7 years from the date of the\n                    transaction for audit and regulatory purposes."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _c("strong", [_vm._v("Cookies and Technical Information:")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Session Cookies: Retained only for the duration of your browsing session."
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Analytics Data: Retained for up to 2 years.")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "After these periods, your personal data will be securely managed, ensuring privacy and compliance\n                with applicable laws."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c("strong", [_vm._v("Access:")]),
        _vm._v(" Request a copy of the personal data we hold about you.")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Rectification:")]),
        _vm._v(" Request correction of any inaccurate or incomplete data.")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Erasure:")]),
        _vm._v(
          " Request deletion of your personal data when it is no longer necessary\n                    for the purposes for which it was collected."
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Restriction:")]),
        _vm._v(
          " Request restriction of processing under certain circumstances.\n                "
        )
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Data Portability:")]),
        _vm._v(" Request transfer of your data to another party.")
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Object:")]),
        _vm._v(
          " Object to the processing of your personal data under certain\n                    conditions."
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("8. COOKIES AND TRACKING TECHNOLOGIES")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                We use cookies and similar technologies to enhance your experience on our website. You can manage\n                your cookie preferences through your browser settings.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("h3", [_vm._v("9. CHANGES TO THIS PRIVACY POLICY")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                We may update this Privacy Policy from time to time. Any changes will be posted on this page, and\n                where appropriate, notified to you by email.\n            "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticStyle: { "margin-bottom": "0.5rem" } }, [
      _c("strong", [_vm._v("Postal Address:")]),
      _vm._v(
        " No.6, Jalan Tahana, Kawasan\n                    Perindustrian Tampoi, 81200 Johor\n                    Bahru, Johor, Malaysia."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticStyle: { "margin-bottom": "0.5rem" } }, [
      _c("strong", [_vm._v("Phone:")]),
      _vm._v(" +607-235 1103 (Hunting Line)")
    ])
  }
]
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-503e0258_0", { source: "\n.header-container[data-v-503e0258] {\r\n    text-align: center;\r\n    background-color: #3663e6;\r\n    padding: 20px;\r\n    max-width: 1200px;\r\n    margin: 3rem auto 0 auto;\r\n    border-top-left-radius: 1rem;\r\n    border-top-right-radius: 1rem;\n}\n.header-title[data-v-503e0258] {\r\n    color: white;\n}\n.content-container[data-v-503e0258] {\r\n    background: white;\r\n    padding: 20px 50px;\r\n    max-width: 1200px;\r\n    margin: 0rem auto 3rem auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    border-bottom-left-radius: 1rem;\r\n    border-bottom-right-radius: 1rem;\n}\nh1[data-v-503e0258],\r\nh3[data-v-503e0258] {\r\n    margin: 1rem 0;\r\n    color: black;\n}\nul[data-v-503e0258] {\r\n    margin: 0;\r\n    padding: 0 0 0 20px;\n}\nli[data-v-503e0258] {\r\n    margin-bottom: 1rem;\n}\na[data-v-503e0258] {\r\n    color: #007bff;\r\n    text-decoration: none;\n}\na[data-v-503e0258]:hover {\r\n    text-decoration: underline;\n}\np[data-v-503e0258] {\r\n    text-align: justify;\n}\n@media (max-width: 575.99px) {\n.header-container[data-v-503e0258] {\r\n        margin: 1.5rem 2rem 0 2rem;\n}\n.content-container[data-v-503e0258] {\r\n        font-size: 0.875rem;\r\n        margin: 0rem 2rem 1.5rem 2rem;\r\n        padding: 20px 30px;\n}\nh1[data-v-503e0258] {\r\n        font-size: 2.5rem;\n}\nli[data-v-503e0258] {\r\n        margin-bottom: 0.75rem;\n}\n}\r\n", map: {"version":3,"sources":["../myinvois/myinvois/public/js/privacy_policy/Home.vue"],"names":[],"mappings":";AAsNA;IACA,kBAAA;IACA,yBAAA;IACA,aAAA;IACA,iBAAA;IACA,wBAAA;IACA,4BAAA;IACA,6BAAA;AACA;AAEA;IACA,YAAA;AACA;AAEA;IACA,iBAAA;IACA,kBAAA;IACA,iBAAA;IACA,2BAAA;IACA,aAAA;IACA,sBAAA;IACA,yCAAA;IACA,+BAAA;IACA,gCAAA;AACA;AAEA;;IAEA,cAAA;IACA,YAAA;AACA;AAEA;IACA,SAAA;IACA,mBAAA;AACA;AAEA;IACA,mBAAA;AACA;AAEA;IACA,cAAA;IACA,qBAAA;AACA;AAEA;IACA,0BAAA;AACA;AAEA;IACA,mBAAA;AACA;AAEA;AACA;QACA,0BAAA;AACA;AAEA;QACA,mBAAA;QACA,6BAAA;QACA,kBAAA;AACA;AAEA;QACA,iBAAA;AACA;AAEA;QACA,sBAAA;AACA;AACA","file":"Home.vue","sourcesContent":["<template>\r\n    <div>\r\n        <div class=\"header-container\">\r\n            <h1 class=\"header-title\">Privacy Policy</h1>\r\n        </div>\r\n        <div class=\"content-container\">\r\n            <p><strong>Last Updated:</strong> 1st Jan 2025</p>\r\n            <p>\r\n                <strong>Win2 Food Marketing Sdn. Bhd</strong>. (\"we,\" \"us,\" \"our\") is committed to protecting your privacy and ensuring\r\n                your personal data is handled securely and in compliance with applicable laws. This Privacy Policy\r\n                explains how we collect, use, and safeguard your information, particularly when interacting with us\r\n                through our e-invoice digital forms.\r\n            </p>\r\n\r\n            <section>\r\n                <h3>1. WHO ARE WE</h3>\r\n                <p>\r\n                    When this Privacy Policy refers to \"we\" or \"us,\" it means Win2 Food Marketing Sdn. Bhd. and its\r\n                    related entities.\r\n                </p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>2. WHAT TYPE OF INFORMATION DO WE COLLECT?</h3>\r\n                <ul>\r\n                    <li><strong>Personal Identification Information:</strong> Your name, personal tax TIN ID,\r\n                        identification number, email address, mobile phone number, address, and postal code.</li>\r\n                    <li><strong>Company Information:</strong> Your company name, company registration number, company\r\n                        tax TIN number, SST number, email address, and phone number.</li>\r\n                    <li><strong>Interaction Details:</strong> Information about your interactions with us, including any\r\n                        complaints or comments you made, details of purchases, and how and when you contact us.</li>\r\n                    <li><strong>Shopping Preferences:</strong> Information about your preferences, such as preferred\r\n                        stores or products.</li>\r\n                    <li><strong>Technical Information:</strong> Details of your visits to our websites, including IP\r\n                        address, browser type, and pages visited.</li>\r\n                    <li><strong>Cookies and Similar Technologies:</strong> Information gathered by the use of cookies to\r\n                        enhance your experience on our website.</li>\r\n                    <li><strong>Third-Party Information:</strong> Information received from affiliates, referral\r\n                        programs, marketing service providers, or publicly available sources.</li>\r\n                </ul>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>3. HOW AND WHY DO WE USE YOUR PERSONAL DATA?</h3>\r\n                <ul>\r\n                    <li><strong>Comply with Legal Obligations:</strong> To fulfill regulatory requirements, including\r\n                        LHDN e-invoice compliance.</li>\r\n                    <li><strong>Provide and Improve Our Services:</strong> To manage your account, process requests, and\r\n                        enhance your experience with our services.</li>\r\n                    <li><strong>Personalization:</strong> To tailor promotions, services, and products to your\r\n                        preferences.</li>\r\n                    <li><strong>Communication:</strong> To respond to your inquiries, feedback, or complaints.</li>\r\n                    <li><strong>Fraud Prevention and Security:</strong> To safeguard our customers, employees, and\r\n                        business from illegal activities.</li>\r\n                </ul>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>4. HOW DO WE PROTECT YOUR PERSONAL DATA?</h3>\r\n                <p>\r\n                    We prioritize the security of your personal data by implementing robust technical and organizational\r\n                    measures to prevent unauthorized access, disclosure, or alteration of your information. These\r\n                    measures include encryption, access control, and regular security audits.\r\n                </p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>5. SHARING YOUR PERSONAL DATA</h3>\r\n                <p>We may share your personal data with trusted third parties under the following conditions:</p>\r\n                <ul>\r\n                    <li><strong>Regulatory Compliance</strong>\r\n                        <ul>\r\n                            <li>Information may be disclosed to Malaysian regulatory bodies, such as:\r\n                                <ul>\r\n                                    <li>Lembaga Hasil Dalam Negeri Malaysia (LHDN).</li>\r\n                                    <li>Royal Malaysian Customs Department.</li>\r\n                                </ul>\r\n                            </li>\r\n                            <li>Purpose: To fulfill tax, e-invoicing, and SST compliance obligations.</li>\r\n                        </ul>\r\n                    </li>\r\n                    <li><strong>Third-Party Service Providers</strong>\r\n                        <ul>\r\n                            <li>We collaborate with service providers to support business operations, such as:\r\n                                <ul>\r\n                                    <li>Payment Processors: To handle secure payments and refunds.</li>\r\n                                    <li>Cloud Storage Providers: For safe data storage within Malaysia or countries with\r\n                                        equivalent data protection laws.</li>\r\n                                    <li>IT Support and Cybersecurity Firms: To ensure system and data security.</li>\r\n                                </ul>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li><strong>Marketing and Advertising Partners</strong>\r\n                        <ul>\r\n                            <li>With your explicit consent, your data may be shared with marketing agencies to:\r\n                                <ul>\r\n                                    <li>Deliver personalized advertisements.</li>\r\n                                    <li>Offer promotional deals relevant to your preferences.</li>\r\n                                </ul>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li><strong>Affiliates or Business Partners</strong>\r\n                        <ul>\r\n                            <li>Data may be shared with affiliated companies or joint venture partners for:\r\n                                <ul>\r\n                                    <li>Operational purposes, such as shared systems or customer support.</li>\r\n                                    <li>In compliance with Malaysia’s Personal Data Protection Act (PDPA).</li>\r\n                                </ul>\r\n                            </li>\r\n                        </ul>\r\n                    </li>\r\n                    <li><strong>Legal and Risk Management</strong>\r\n                        <ul>\r\n                            <li>Personal data may be disclosed to:\r\n                                <ul>\r\n                                    <li>Legal counsel, auditors, or insurance companies.</li>\r\n                                </ul>\r\n                            </li>\r\n                            <li>Purpose: For claims, disputes, or risk assessments.</li>\r\n                        </ul>\r\n                    </li>\r\n                </ul>\r\n                <p>We ensure that all third parties handling your personal data adhere to strict confidentiality and\r\n                    security standards as required by the PDPA and other relevant Malaysian laws.</p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>6. DATA RETENTION</h3>\r\n                <p>Whenever we collect or process your personal data, we will only keep it for as long as is necessary\r\n                    for the purpose for which it was collected or to comply with legal and regulatory requirements. For\r\n                    tax and compliance purposes, we may retain your data for a minimum of seven (7) years. At the end of\r\n                    that retention period, your data will either be deleted completely or anonymized, for example by\r\n                    aggregation with other data so that it can be used in a non-identifiable way for statistical\r\n                    analysis and business planning.</p>\r\n                <p>Key retention details include:</p>\r\n                <ul>\r\n                    <li><strong>Personal Identification Information:</strong> Retained for 7 years after the end of our\r\n                        business relationship to comply with Malaysian taxation and accounting laws.</li>\r\n                    <li><strong>Company Information:</strong> Retained for 7 years to meet statutory obligations under\r\n                        the Companies Act 2016 and related regulations.</li>\r\n                    <li><strong>Transaction and Interaction Details:</strong> Retained for 7 years from the date of the\r\n                        transaction for audit and regulatory purposes.</li>\r\n                    <li><strong>Cookies and Technical Information:</strong>\r\n                        <ul>\r\n                            <li>Session Cookies: Retained only for the duration of your browsing session.</li>\r\n                            <li>Analytics Data: Retained for up to 2 years.</li>\r\n                        </ul>\r\n                    </li>\r\n                </ul>\r\n                <p>After these periods, your personal data will be securely managed, ensuring privacy and compliance\r\n                    with applicable laws.</p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>7. YOUR RIGHTS</h3>\r\n                <p>You have the right to:</p>\r\n                <ul>\r\n                    <li><strong>Access:</strong> Request a copy of the personal data we hold about you.</li>\r\n                    <li><strong>Rectification:</strong> Request correction of any inaccurate or incomplete data.</li>\r\n                    <li><strong>Erasure:</strong> Request deletion of your personal data when it is no longer necessary\r\n                        for the purposes for which it was collected.</li>\r\n                    <li><strong>Restriction:</strong> Request restriction of processing under certain circumstances.\r\n                    </li>\r\n                    <li><strong>Data Portability:</strong> Request transfer of your data to another party.</li>\r\n                    <li><strong>Object:</strong> Object to the processing of your personal data under certain\r\n                        conditions.</li>\r\n                </ul>\r\n                <p>To exercise any of these rights, please email us at <a\r\n                        :href=\"`mailto:einvoice@win2food.com.my`\">einvoice@win2food.com.my</a>.</p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>8. COOKIES AND TRACKING TECHNOLOGIES</h3>\r\n                <p>\r\n                    We use cookies and similar technologies to enhance your experience on our website. You can manage\r\n                    your cookie preferences through your browser settings.\r\n                </p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>9. CHANGES TO THIS PRIVACY POLICY</h3>\r\n                <p>\r\n                    We may update this Privacy Policy from time to time. Any changes will be posted on this page, and\r\n                    where appropriate, notified to you by email.\r\n                </p>\r\n            </section>\r\n\r\n            <section>\r\n                <h3>10. CONTACT US</h3>\r\n                <p>If you have any questions about this Privacy Policy or our data practices, please contact us at:</p>\r\n                <ul>\r\n                    <li style=\"margin-bottom: 0.5rem;\"><strong>Email:</strong> <a\r\n                            :href=\"`mailto:einvoice@win2food.com.my`\">einvoice@win2food.com.my</a>\r\n                    </li>\r\n                    <li style=\"margin-bottom: 0.5rem;\"><strong>Postal Address:</strong> No.6, Jalan Tahana, Kawasan\r\n                        Perindustrian Tampoi, 81200 Johor\r\n                        Bahru, Johor, Malaysia.</li>\r\n                    <li style=\"margin-bottom: 0.5rem;\"><strong>Phone:</strong> +607-235 1103 (Hunting Line)</li>\r\n                </ul>\r\n                <p>By providing your information to us, you agree to the terms outlined in this Privacy Policy.</p>\r\n            </section>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\nexport default {\r\n    name: \"PrivacyPolicy\",\r\n};\r\n</script>\r\n\r\n<style scoped>\r\n.header-container {\r\n    text-align: center;\r\n    background-color: #3663e6;\r\n    padding: 20px;\r\n    max-width: 1200px;\r\n    margin: 3rem auto 0 auto;\r\n    border-top-left-radius: 1rem;\r\n    border-top-right-radius: 1rem;\r\n}\r\n\r\n.header-title {\r\n    color: white;\r\n}\r\n\r\n.content-container {\r\n    background: white;\r\n    padding: 20px 50px;\r\n    max-width: 1200px;\r\n    margin: 0rem auto 3rem auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n    border-bottom-left-radius: 1rem;\r\n    border-bottom-right-radius: 1rem;\r\n}\r\n\r\nh1,\r\nh3 {\r\n    margin: 1rem 0;\r\n    color: black;\r\n}\r\n\r\nul {\r\n    margin: 0;\r\n    padding: 0 0 0 20px;\r\n}\r\n\r\nli {\r\n    margin-bottom: 1rem;\r\n}\r\n\r\na {\r\n    color: #007bff;\r\n    text-decoration: none;\r\n}\r\n\r\na:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\np {\r\n    text-align: justify;\r\n}\r\n\r\n@media (max-width: 575.99px) {\r\n    .header-container {\r\n        margin: 1.5rem 2rem 0 2rem;\r\n    }\r\n\r\n    .content-container {\r\n        font-size: 0.875rem;\r\n        margin: 0rem 2rem 1.5rem 2rem;\r\n        padding: 20px 30px;\r\n    }\r\n\r\n    h1 {\r\n        font-size: 2.5rem;\r\n    }\r\n\r\n    li {\r\n        margin-bottom: 0.75rem;\r\n    }\r\n}\r\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-503e0258"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../myinvois/myinvois/public/js/privacy_policy/Home.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__